/* Review candidate: Store 1 navigation and successful cart additions only. */
(function installStore1DirectMetaNavigation() {
  'use strict';
  const ACTIVATION_ENABLED = true;
  const SHOP = 'vxh0yn-s5.myshopify.com';
  const PIXEL = '1134305462278100';
  const MATCHING_FEATURE = 'AutomaticMatching';
  const SDK = 'https://connect.facebook.net/en_US/fbevents.js';
  const CONFIG_ID = 'halo-store1-meta-navigation-config';
  const TRACK_CART_FN = '__haloStore1TrackCartAddition';
  const INSTANCE = '__haloStore1DirectMetaNavigationInstalled';
  const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  if (!ACTIVATION_ENABLED) return;

  function exactKeys(value, keys) {
    return value && typeof value === 'object' && !Array.isArray(value) &&
      Object.keys(value).length === keys.length && keys.every(key => Object.hasOwn(value, key));
  }
  let config;
  let configNode;
  let configText;
  try {
    const node = document.getElementById(CONFIG_ID);
    if (!node || typeof node.textContent !== 'string' || node.textContent.length > 2000) return;
    config = JSON.parse(node.textContent);
    if (!exactKeys(config, ['schema_version', 'shop_domain', 'page_type', 'currency', 'product']) ||
        config.schema_version !== 1 || config.shop_domain !== SHOP ||
        !['page', 'product'].includes(config.page_type) || typeof config.currency !== 'string') return;
    configNode = node;
    configText = node.textContent;
    if (window[INSTANCE]) return;
    Object.defineProperty(window, INSTANCE, { value: true });
  } catch { return; }

  function productParameters() {
    if (config.page_type !== 'product' || config.currency !== 'USD') return null;
    const product = config.product;
    if (!exactKeys(product, ['product_id', 'variant_id', 'price_cents']) ||
        typeof product.product_id !== 'string' || !/^[1-9][0-9]{0,19}$/.test(product.product_id) ||
        typeof product.variant_id !== 'string' || !/^[1-9][0-9]{0,19}$/.test(product.variant_id) ||
        !Number.isSafeInteger(product.price_cents) || product.price_cents < 0 || product.price_cents > 100000000) return null;
    return {
      content_type: 'product', content_ids: [product.variant_id],
      contents: [{ id: product.variant_id, quantity: 1 }], currency: 'USD',
      value: product.price_cents / 100,
      store1_product_ids: [product.product_id], store1_variant_ids: [product.variant_id],
    };
  }

  let sdkPromise = null;
  let sdkFbq = null;
  let sdkDisabled = false;
  let sdkPixel = null;
  let sdkMetadata = null;
  let sdkMetadataGetter = null;
  let sdkInstance = null;
  let sdkOptOut = null;
  let sdkSkipOpenbridge = null;
  let sdkOptIns = null;
  let sdkIsOptedOut = null;
  let sdkIsOptedIn = null;
  let sdkCallMethod = null;
  let sdkInitRequested = false;
  let sdkRevokeAttempted = false;
  let emptyReferrerGetter = null;
  let operationId = '';
  let active = true;
  const seen = new Set();
  const seenCartOperations = new Set();
  function permitted() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' ||
          typeof privacy.marketingAllowed !== 'function' || typeof privacy.saleOfDataAllowed !== 'function') return false;
      return privacy.analyticsProcessingAllowed() === true &&
        privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true;
    } catch { return false; }
  }

  function numericId(value) {
    if (typeof value === 'number') {
      if (!Number.isSafeInteger(value) || value <= 0) return '';
      return String(value);
    }
    return typeof value === 'string' && /^[1-9][0-9]{0,19}$/.test(value) ? value : '';
  }

  function operationIdForCart() {
    const value = window.crypto?.randomUUID?.();
    return typeof value === 'string' && UUID.test(value) ? value.toLowerCase() : '';
  }

  function cartLinesParameters(lines) {
    if (!Array.isArray(lines) || lines.length < 1 || lines.length > 100 || config.currency !== 'USD') return null;
    const productIds = new Set();
    const contentIds = [];
    const contents = [];
    let totalCents = 0;
    let quantity = 0;
    for (const line of lines) {
      if (!exactKeys(line, ['product_id', 'variant_id', 'quantity', 'price_cents'])) return null;
      const productId = numericId(line.product_id);
      const variantId = numericId(line.variant_id);
      const count = line.quantity;
      const priceCents = line.price_cents;
      if (!productId || !variantId || !Number.isSafeInteger(count) || count < 1 || count > 1000 ||
          !Number.isSafeInteger(priceCents) || priceCents < 0 || priceCents > 100000000) return null;
      const lineCents = count * priceCents;
      if (!Number.isSafeInteger(lineCents) || lineCents > 100000000) return null;
      totalCents += lineCents;
      quantity += count;
      if (totalCents > 100000000 || quantity > 1000) return null;
      productIds.add(productId);
      contentIds.push(variantId);
      contents.push({ id: variantId, quantity: count });
    }
    const operationId = operationIdForCart();
    if (!operationId) return null;
    return {
      operationId,
      parameters: {
        content_type: 'product', content_ids: contentIds, contents,
        currency: 'USD', value: totalCents / 100, num_items: quantity,
        store1_product_ids: [...productIds], store1_variant_ids: contentIds.slice(),
      },
    };
  }

  // Proposed extra Store 1 protection. Never read the native incoming referrer.
  // Keep the existing theme guard/stubs/observer and no-referrer policy intact.
  function installEmptyReferrerShield() {
    try {
      if (emptyReferrerGetter) {
        const descriptor = Object.getOwnPropertyDescriptor(document, 'referrer');
        return descriptor?.get === emptyReferrerGetter && descriptor.configurable === false;
      }
      const empty = function protectedEmptyReferrer() { return ''; };
      Object.defineProperty(document, 'referrer', { get: empty, configurable: false, enumerable: true });
      const descriptor = Object.getOwnPropertyDescriptor(document, 'referrer');
      const installed = descriptor?.get === empty && descriptor.configurable === false;
      if (installed) emptyReferrerGetter = empty;
      return installed;
    } catch { return false; }
  }

  /* Local helper only. Invoke inside the Store 1 + consent gate, before any SDK load.
   * No SDK, source URL, cookie, incoming referrer or existing image value is read.
   * Existing document no-referrer policy remains required. This is a same-realm
   * guard for ordinary image property/attribute writes, not a sandbox boundary.
   */
  const installStore1ImageNoReferrerShield = (function createImageShieldInstaller() {
    'use strict';
    let installed = null;
  
    function domString(value) {
      // Match DOMString's Symbol rejection and coerce an object name only once.
      if (typeof value === 'symbol') throw new TypeError('ATTRIBUTE_NAME_INVALID');
      return String(value);
    }
  
    return function installStore1ImageNoReferrerShield() {
      try {
        const ImageElement = window.HTMLImageElement;
        const ElementClass = window.Element;
        const ImageConstructor = window.Image;
        if (typeof ImageElement !== 'function' || typeof ElementClass !== 'function' ||
            typeof ImageConstructor !== 'function') return false;
        const prototype = ImageElement.prototype;
        const apply = Reflect.apply;
        if (installed) {
          const policy = Object.getOwnPropertyDescriptor(prototype, 'referrerPolicy');
          const attribute = Object.getOwnPropertyDescriptor(prototype, 'setAttribute');
          const attributeNS = Object.getOwnPropertyDescriptor(prototype, 'setAttributeNS');
          return prototype === installed.prototype && policy?.get === installed.get &&
            policy?.set === installed.set && policy.configurable === false &&
            attribute?.value === installed.attribute && attribute.configurable === false && attribute.writable === false &&
            attributeNS?.value === installed.attributeNS && attributeNS.configurable === false && attributeNS.writable === false;
        }
        const policy = Object.getOwnPropertyDescriptor(prototype, 'referrerPolicy');
        const attribute = Object.getOwnPropertyDescriptor(ElementClass.prototype, 'setAttribute');
        const attributeNS = Object.getOwnPropertyDescriptor(ElementClass.prototype, 'setAttributeNS');
        if (!prototype || !Object.isExtensible(prototype) || !policy || policy.configurable !== true ||
            typeof policy.get !== 'function' || typeof policy.set !== 'function' ||
            typeof attribute?.value !== 'function' || typeof attributeNS?.value !== 'function' ||
            Object.getOwnPropertyDescriptor(prototype, 'setAttribute') ||
            Object.getOwnPropertyDescriptor(prototype, 'setAttributeNS')) return false;
  
        const nativeGet = policy.get;
        const nativeSet = policy.set;
        const nativeAttribute = attribute.value;
        const nativeAttributeNS = attributeNS.value;
        const get = function protectedImageReferrerPolicy() { return 'no-referrer'; };
        const set = function protectedImageReferrerPolicyWrite() {
          // Ignore the supplied value entirely, including its conversion hooks.
          apply(nativeSet, this, ['no-referrer']);
        };
        const setAttribute = function protectedImageSetAttribute(name) {
          if (arguments.length < 2) return apply(nativeAttribute, this, arguments);
          const normalized = domString(name);
          const args = Array.prototype.slice.call(arguments);
          args[0] = normalized;
          if (normalized.toLowerCase() === 'referrerpolicy') args[1] = 'no-referrer';
          return apply(nativeAttribute, this, args);
        };
        const setAttributeNS = function protectedImageSetAttributeNS(namespace, name) {
          if (arguments.length < 3) return apply(nativeAttributeNS, this, arguments);
          const normalizedNamespace = namespace == null ? null : domString(namespace);
          const normalizedName = domString(name);
          const args = Array.prototype.slice.call(arguments);
          args[0] = normalizedNamespace;
          args[1] = normalizedName;
          if ((normalizedNamespace === null || normalizedNamespace === '') &&
              normalizedName.toLowerCase() === 'referrerpolicy') args[2] = 'no-referrer';
          return apply(nativeAttributeNS, this, args);
        };
  
        // All preflight checks precede irreversible hooks. Any subsequent failure
        // returns false; callers must skip SDK work rather than weaken the guard.
        Object.defineProperty(prototype, 'referrerPolicy', {
          get, set, enumerable: policy.enumerable, configurable: false,
        });
        Object.defineProperty(prototype, 'setAttribute', {
          value: setAttribute, enumerable: attribute.enumerable, writable: false, configurable: false,
        });
        Object.defineProperty(prototype, 'setAttributeNS', {
          value: setAttributeNS, enumerable: attributeNS.enumerable, writable: false, configurable: false,
        });
  
        // Detached, newly constructed fixtures only. No src is assigned and no
        // existing image/attribute is inspected. Use the captured native getter
        // to verify the internal reflected policy, not our constant getter.
        const fixtures = [new ImageConstructor(), document.createElement('img')];
        for (const image of fixtures) {
          if (Object.getPrototypeOf(image) !== prototype) return false;
          image.referrerPolicy = 'origin';
          if (apply(nativeGet, image, []) !== 'no-referrer') return false;
          apply(nativeSet, image, ['origin']);
          image.setAttribute('referrerpolicy', 'origin');
          if (apply(nativeGet, image, []) !== 'no-referrer') return false;
          apply(nativeSet, image, ['origin']);
          image.setAttributeNS(null, 'referrerpolicy', 'origin');
          if (apply(nativeGet, image, []) !== 'no-referrer') return false;
        }
        installed = { prototype, get, set, attribute: setAttribute, attributeNS: setAttributeNS };
        return true;
      } catch { return false; }
    };
  }());
  
  /* Store 1 only, inside strict consent/shop gate, before the SDK.
   * Blind removal of two known legacy SDK keys. Never enumerate storage or read
   * their existing values. Other keys retain native behavior; values are opaque.
   */
  const installStore1LegacyReferrerStorageShield = (function createLegacyStorageShieldInstaller() {
    'use strict';
    let installed = null;
    const keys = ['lastExternalReferrer', 'lastExternalReferrerTime'];
    function keyString(value) {
      if (typeof value === 'symbol') throw new TypeError('STORAGE_KEY_INVALID');
      return String(value);
    }
    return function installStore1LegacyReferrerStorageShield() {
      try {
        const prototype = window.Storage?.prototype;
        if (!prototype) return false;
        if (installed) {
          const get = Object.getOwnPropertyDescriptor(prototype, 'getItem');
          const set = Object.getOwnPropertyDescriptor(prototype, 'setItem');
          return prototype === installed.prototype && get?.value === installed.get &&
            set?.value === installed.set && get.configurable === false && set.configurable === false &&
            get.writable === false && set.writable === false;
        }
        const get = Object.getOwnPropertyDescriptor(prototype, 'getItem');
        const set = Object.getOwnPropertyDescriptor(prototype, 'setItem');
        const remove = Object.getOwnPropertyDescriptor(prototype, 'removeItem');
        if (!get || !set || !remove || get.configurable !== true || set.configurable !== true ||
            typeof get.value !== 'function' || typeof set.value !== 'function' ||
            typeof remove.value !== 'function') return false;
        const local = window.localStorage;
        const session = window.sessionStorage;
        if (Object.getPrototypeOf(local) !== prototype || Object.getPrototypeOf(session) !== prototype ||
            Object.getOwnPropertyDescriptor(local, 'getItem') || Object.getOwnPropertyDescriptor(local, 'setItem') ||
            Object.getOwnPropertyDescriptor(session, 'getItem') || Object.getOwnPropertyDescriptor(session, 'setItem')) return false;
        const apply = Reflect.apply;
        const protectedGet = function protectedLegacyReferrerRead(key) {
          if (arguments.length < 1) return apply(get.value, this, arguments);
          const normalized = keyString(key);
          if (keys.includes(normalized)) return null;
          const args = Array.prototype.slice.call(arguments); args[0] = normalized;
          return apply(get.value, this, args);
        };
        const protectedSet = function protectedLegacyReferrerWrite(key) {
          if (arguments.length < 2) return apply(set.value, this, arguments);
          const normalized = keyString(key);
          if (keys.includes(normalized)) return undefined;
          const args = Array.prototype.slice.call(arguments); args[0] = normalized;
          return apply(set.value, this, args);
        };
        Object.defineProperty(prototype, 'getItem', {
          value: protectedGet, enumerable: get.enumerable, configurable: false, writable: false,
        });
        Object.defineProperty(prototype, 'setItem', {
          value: protectedSet, enumerable: set.enumerable, configurable: false, writable: false,
        });
        for (const storage of [local, session]) for (const key of keys) apply(remove.value, storage, [key]);
        installed = { prototype, get: protectedGet, set: protectedSet };
        return true;
      } catch { return false; }
    };
  }());

  function configStillCurrent() {
    try {
      return config.shop_domain === SHOP && document.getElementById(CONFIG_ID) === configNode &&
        configNode.textContent === configText;
    } catch { return false; }
  }
  function disableSdkAndRevoke() {
    sdkDisabled = true;
    if (!sdkInitRequested || sdkRevokeAttempted || !sdkFbq || typeof sdkCallMethod !== 'function') return;
    sdkRevokeAttempted = true;
    try {
      // Retain the original owned SDK method before init. Never dispatch via
      // window.fbq or a callMethod that may have changed after readiness.
      sdkCallMethod.call(sdkFbq, 'consent', 'revoke');
    } catch { /* Best effort only; keep our own sends disabled. */ }
  }
  function sdkSafetyStillCurrent() {
    try {
      if (!active || !permitted() || sdkDisabled || !configStillCurrent() ||
          !sdkFbq || window.fbq !== sdkFbq || window._fbq !== sdkFbq || sdkFbq.callMethod !== sdkCallMethod ||
          !installEmptyReferrerShield() || !installStore1ImageNoReferrerShield() ||
          !installStore1LegacyReferrerStorageShield() || !sdkPixel || sdkPixel.id !== PIXEL ||
          sdkPixel.trackSingleOnly !== true || sdkFbq.instance?.pluginConfig !== sdkMetadata ||
          sdkMetadata?.get !== sdkMetadataGetter || sdkFbq.instance !== sdkInstance ||
          sdkInstance?.optOut !== sdkOptOut || sdkInstance.skipOpenbridge !== sdkSkipOpenbridge || sdkInstance.optIns !== sdkOptIns ||
          sdkOptIns?.isOptedOut !== sdkIsOptedOut || sdkOptIns?.isOptedIn !== sdkIsOptedIn) return false;
      return sdkMetadataGetter.call(sdkMetadata, PIXEL, 'skipOpenbridge')?.enabled === true &&
        sdkIsOptedOut.call(sdkOptIns, PIXEL, MATCHING_FEATURE) === true &&
        sdkIsOptedIn.call(sdkOptIns, PIXEL, MATCHING_FEATURE) === false;
    } catch { return false; }
  }

  function loadSdk() {
    if (sdkPromise) return sdkPromise;
    sdkPromise = new Promise((resolve, reject) => {
      if (!active || !permitted() || sdkDisabled || !configStillCurrent() || window.fbq || window._fbq || !installEmptyReferrerShield() ||
          !installStore1ImageNoReferrerShield() || !installStore1LegacyReferrerStorageShield()) {
        reject(new Error('SDK_UNAVAILABLE')); return;
      }
      const fbq = function queueMetaCommand() {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
        else fbq.queue.push(arguments);
      };
      fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0'; fbq.queue = [];
      fbq.disablePushState = true;
      window.fbq = fbq; window._fbq = fbq; sdkFbq = fbq;
      fbq('set', 'autoConfig', false, PIXEL);
      fbq('skipOpenbridge', PIXEL);
      // The current SDK accepts this per-pixel feature opt-out before init;
      // prevent remote partner matching configuration from extracting PII.
      fbq('optOut', PIXEL, MATCHING_FEATURE);
      const script = document.createElement('script');
      script.async = true; script.src = SDK; script.referrerPolicy = 'no-referrer';
      script.onload = () => {
        if (!active || !permitted() || sdkDisabled || typeof fbq.callMethod !== 'function') {
          reject(new Error('SDK_UNAVAILABLE')); return;
        }
        // Read only exact per-pixel configuration metadata. No getState,
        // userdata, cookies, URL or arbitrary SDK state inspection.
        const instance = fbq.instance;
        const metadata = instance?.pluginConfig;
        const optIns = instance?.optIns;
        if (typeof fbq.addInitHandler !== 'function' || typeof fbq.set !== 'function' || typeof metadata?.get !== 'function' ||
            typeof instance?.optOut !== 'function' || typeof instance?.skipOpenbridge !== 'function' || typeof optIns?.isOptedOut !== 'function' ||
            typeof optIns?.isOptedIn !== 'function') {
          sdkDisabled = true; reject(new Error('SDK_UNAVAILABLE')); return;
        }
        try {
          // Do not initialize the pixel (or request its remote configuration)
          // until these source-verified per-pixel gates have acknowledged.
          // Both instance methods are independent of an initialized pixel.
          instance.optOut(PIXEL, MATCHING_FEATURE);
          instance.skipOpenbridge(PIXEL);
          if (optIns.isOptedOut(PIXEL, MATCHING_FEATURE) !== true ||
              optIns.isOptedIn(PIXEL, MATCHING_FEATURE) !== false ||
              metadata.get(PIXEL, 'skipOpenbridge')?.enabled !== true ||
              !active || !permitted() || sdkDisabled) {
            sdkDisabled = true; reject(new Error('SDK_UNAVAILABLE')); return;
          }
          fbq.addInitHandler(pixel => {
            try {
              if (!pixel || pixel.id !== PIXEL) return;
              if (!active || !permitted() || sdkDisabled) {
                disableSdkAndRevoke();
                reject(new Error('SDK_UNAVAILABLE')); return;
              }
              instance.optOut(PIXEL, MATCHING_FEATURE);
              if (optIns.isOptedOut(PIXEL, MATCHING_FEATURE) !== true ||
                  optIns.isOptedIn(PIXEL, MATCHING_FEATURE) !== false) {
                disableSdkAndRevoke(); reject(new Error('SDK_UNAVAILABLE')); return;
              }
              // SDK export delegates directly to its validated setter; the
              // queued command form can defer under configuration locks.
              fbq.set('trackSingleOnly', true, PIXEL);
              const skip = metadata.get(PIXEL, 'skipOpenbridge');
              if (skip?.enabled !== true || pixel.trackSingleOnly !== true) {
                disableSdkAndRevoke(); reject(new Error('SDK_UNAVAILABLE')); return;
              }
              sdkPixel = pixel;
              sdkMetadata = metadata;
              sdkMetadataGetter = metadata.get;
              sdkInstance = instance;
              sdkOptOut = instance.optOut;
              sdkSkipOpenbridge = instance.skipOpenbridge;
              sdkOptIns = optIns;
              sdkIsOptedOut = optIns.isOptedOut;
              sdkIsOptedIn = optIns.isOptedIn;
              resolve(fbq);
            } catch { disableSdkAndRevoke(); reject(new Error('SDK_UNAVAILABLE')); }
          });
          sdkCallMethod = fbq.callMethod;
          sdkInitRequested = true;
          fbq('init', PIXEL);
        } catch { disableSdkAndRevoke(); reject(new Error('SDK_UNAVAILABLE')); }
      };
      script.onerror = () => { sdkDisabled = true; fbq.queue.length = 0; reject(new Error('SDK_UNAVAILABLE')); };
      document.head.appendChild(script);
    });
    return sdkPromise;
  }

  async function send(metaName, parameters, suffix) {
    try {
      if (!active || !permitted() || sdkDisabled || seen.has(metaName)) return;
      if (!operationId) {
        const generated = window.crypto?.randomUUID?.();
        if (typeof generated !== 'string' || !UUID.test(generated)) return;
        operationId = generated.toLowerCase();
      }
      const eventOperationId = operationId;
      seen.add(metaName);
      const fbq = await loadSdk();
      if (!active || !permitted() || sdkDisabled || eventOperationId !== operationId) return;
      if (!sdkSafetyStillCurrent()) { disableSdkAndRevoke(); return; }
      fbq('trackSingle', PIXEL, metaName, parameters, { eventID: `halo_store1_direct_${suffix}_${eventOperationId}` });
    } catch { /* No logging, attribution forwarding, fallback, timers or commerce mutation. */ }
  }
  async function sendCart(normalized) {
    try {
      if (!active || !permitted() || sdkDisabled || !normalized ||
          seenCartOperations.has(normalized.operationId) || seenCartOperations.size >= 250) return;
      seenCartOperations.add(normalized.operationId);
      const fbq = await loadSdk();
      if (!active || !permitted() || sdkDisabled) return;
      if (!sdkSafetyStillCurrent()) { disableSdkAndRevoke(); return; }
      fbq('trackSingle', PIXEL, 'AddToCart', normalized.parameters,
        { eventID: `halo_store1_direct_atc_${normalized.operationId}` });
    } catch { /* No logging, retries, fallback, attribution forwarding or commerce mutation. */ }
  }
  try {
    // Theme producers pass only newly requested commercial lines after a
    // successful cart add. No Ajax response, properties or visitor state enter.
    Object.defineProperty(window, TRACK_CART_FN, {
      value(lines) {
        if (!active || !permitted() || sdkDisabled) return;
        try { void sendCart(cartLinesParameters(lines)); } catch { /* Fail closed. */ }
      }, configurable: false, writable: false,
    });
  } catch { /* An occupied namespace cannot weaken navigation tracking. */ }
  function observeCurrentView() {
    if (!active) return;
    if (!permitted()) {
      if (sdkFbq) { sdkDisabled = true; sdkFbq('consent', 'revoke'); }
      return;
    }
    void send('PageView', {}, 'pv');
    const parameters = productParameters();
    if (parameters) void send('ViewContent', parameters, 'vc');
  }
  // Read the API's current Allowed methods; never trust/log consent event detail.
  document.addEventListener('visitorConsentCollected', observeCurrentView);
  window.addEventListener('pagehide', () => { active = false; });
  window.addEventListener('pageshow', event => {
    if (event.persisted !== true) return;
    active = true;
    operationId = '';
    seen.clear();
    observeCurrentView();
  });
  try {
    const privacy = window.Shopify?.customerPrivacy;
    if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
        typeof privacy.marketingAllowed === 'function' && typeof privacy.saleOfDataAllowed === 'function') {
      observeCurrentView();
    } else if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        if (!error) observeCurrentView();
      });
    }
  } catch { /* Missing/unusable privacy API fails closed. */ }
}());
